import JsCookie from 'js-cookie';

function getAttributes() {
    if (IS_SSR) return {};

    const isUS = location.host.includes('petsmart.com');
    const isCA = location.host.includes('petsmart.ca');

    return {
        ...(isUS && { domain: '.petsmart.com' }),
        ...(isCA && { domain: '.petsmart.ca' }),
    };
}

export const Cookie = JsCookie.withAttributes(getAttributes());
